import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EventsList from './widgets/EventsList';


export default function EventsPage() {
  const [selected, setSelected] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSelect = (id: string) => {
    navigate(`/admin/events/event/${id}`);
  };

  return (
    <Grid container direction="column" wrap="nowrap" justifyContent="center">
      <Container maxWidth="xl" disableGutters>

        <Grid item container direction="column" style={{ padding: 24 }}>
          <Typography variant="h6" style={{ marginBottom: 8 }}>Events</Typography>
          <Typography variant="caption">Select or add an event to continue, part of our <Link
            href="https://app.graphcms.com/d8a43d9d6e4547da83051c63f594b7f0/master/content/648979d9c06d4e2389aa9944ab4d9efe/view/53c18833e12b49a2980754996c104ad5"
            target="graphcms">personalized guidance content</Link></Typography>
          <Typography variant="caption" color="error">Must use GraphCMS to upload images and delete events</Typography>
        </Grid>
        <Grid item container>
          <EventsList selected={selected} onSelect={handleSelect}/>
        </Grid>
      </Container>
    </Grid>
  );
}
